export type AuthType = "basic" | "mfa" | "saml" | "none";

export enum ServerAuthType { BASIC = "BASIC", MFA = "MFA", SAML = "SAML", EMERGENCY = "EMERGENCY" }